// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"bTG1O","rc-tabs-bar":"sJzeS","rc-tabs-tab":"r8ksl","rc-tabs-tab-active":"b5Qxc","terms":"rWesr","orderHistory-navigation":"_57fJR","toppingAmountModifierItem":"US2RA"};